import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, addDoc, getDocs } from "firebase/firestore";

const ProducersPage = () => {
  const [producers, setProducers] = useState([]);
  const [formData, setFormData] = useState({ name: "", location: "", type: "" });
  const [successMessage, setSuccessMessage] = useState("");

  // Charger les producteurs existants
  useEffect(() => {
    const fetchProducers = async () => {
      const querySnapshot = await getDocs(collection(db, "producers"));
      setProducers(
        querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      );
    };
    fetchProducers();
  }, []);

  // Enregistrer un producteur
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "producers"), formData);
      setSuccessMessage("Identification réussie !");
      setFormData({ name: "", location: "", type: "" }); // Réinitialiser le formulaire
    } catch (error) {
      console.error("Erreur lors de l'enregistrement :", error);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Identifier un producteur</h1>
      <form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
        <div>
          <label>Nom :</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
            style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
          />
        </div>
        <div>
          <label>Localisation :</label>
          <input
            type="text"
            value={formData.location}
            onChange={(e) =>
              setFormData({ ...formData, location: e.target.value })
            }
            required
            style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
          />
        </div>
        <div>
          <label>Type de production :</label>
          <input
            type="text"
            value={formData.type}
            onChange={(e) =>
              setFormData({ ...formData, type: e.target.value })
            }
            required
            style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
          />
        </div>
        <button
          type="submit"
          style={{
            padding: "10px 20px",
            backgroundColor: "#4caf50",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          Enregistrer
        </button>
      </form>
      {successMessage && (
        <p style={{ color: "green", fontWeight: "bold" }}>{successMessage}</p>
      )}
    </div>
  );
};

export default ProducersPage;
